import React, { useCallback, useEffect, useState } from 'react';
import { format } from 'date-fns';
import { CheckIcon, ArrowPathIcon } from '@heroicons/react/24/outline';

export default function WorkCoachToday() {
  const [todos, setTodos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busyId, setBusyId] = useState(null);

  const fetchTodayTodos = useCallback(async () => {
    setLoading(true);
    try {
      const today = format(new Date(), 'yyyy-MM-dd');
      const res = await fetch(`https://api.insightos.co.uk/api/todos/${today}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });

      const data = await res.json();
      setTodos(Array.isArray(data?.data) ? data.data : []);
    } catch (err) {
      console.error('Failed to fetch today todos:', err);
      setTodos([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTodayTodos();
  }, [fetchTodayTodos]);



  const markLocalDone = (id) => {
    setTodos((prev) => prev.map((todo) => (todo.id === id ? { ...todo, _localDone: true } : todo)));
  };

  const handleApprove = async (id, title) => {
    if (!window.confirm(`Mark "${title}" as completed?`)) return;

    setBusyId(id);
    markLocalDone(id);

    try {
      const res = await fetch('https://api.insightos.co.uk/api/approvetodo', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ id }),
      });

      if (!res.ok) throw new Error('Failed to complete todo');
      fetchTodayTodos();
    } catch (err) {
      console.error('Failed to complete todo:', err);
      setTodos((prev) => prev.map((todo) => (todo.id === id ? { ...todo, _localDone: false } : todo)));
      window.alert('Failed to complete todo. Please try again.');
    } finally {
      setBusyId(null);
    }
  };

  const completedCount = todos.filter((todo) => todo.Complete === 1 || todo.Complete === '1' || todo._localDone).length;

  return (
    <div className="mt-3 rounded-2xl border border-white/35 bg-gradient-to-br from-indigo-100/70 via-sky-100/65 to-emerald-100/60 p-3 shadow-[0_12px_30px_rgba(15,23,42,0.22),inset_0_1px_0_rgba(255,255,255,0.35)] backdrop-blur-xl">
      <div className="mb-2 flex items-center justify-between">
        <div>
          <h3 className="text-xs font-semibold uppercase tracking-wide text-indigo-900/85">Today's Admin Actions</h3>
          <p className="text-[11px] text-indigo-900/70">{completedCount}/{todos.length} completed</p>
        </div>
        <button
          onClick={fetchTodayTodos}
          className="inline-flex items-center gap-1 rounded-full border border-white/45 bg-white/70 px-2 py-1 text-[10px] font-semibold text-indigo-800 hover:bg-white"
          title="Refresh"
        >
          <ArrowPathIcon className="h-3.5 w-3.5" />
          Refresh
        </button>
      </div>

      {loading ? (
        <div className="py-3 text-center text-[11px] text-indigo-900/70">Loading today's actions...</div>
      ) : todos.length === 0 ? (
        <div className="rounded-xl border border-white/45 bg-white/70 p-3 text-center text-[11px] text-indigo-900/70">
          No actions for today.
        </div>
      ) : (
        <div className="space-y-2">
          {todos.map((todo) => {
            const completed =
  todo.Complete === 1 ||
  todo.Complete === '1' ||
  todo._localDone === true;

const incomplete = !completed;
            
            return (
              <div
                key={todo.id}
                className={`flex items-center justify-between gap-2 rounded-xl border px-2.5 py-2 ${
   completed
      ? 'bg-emerald-500/90 border-emerald-600 text-white'
      : 'bg-red-500/90 border-red-600 text-white'
}`}
              >
                <div className="min-w-0 flex-1">
                  <p className={`truncate text-xs font-semibold ${completed || incomplete ? 'text-white' : 'text-gray-900'}`}>{todo.Title}</p>
                  <p className="text-[10px] opacity-90">{todo.TimeFrom || '--:--'} to {todo.TimeTo || '--:--'}</p>
                </div>
                <button
                  onClick={() => handleApprove(todo.id, todo.Title || 'task')}
                  disabled={busyId === todo.id || completed}
                  className={`inline-flex h-7 w-7 items-center justify-center rounded-full border ${
                    completed
                      ? 'cursor-default border-white/70 bg-white/20 text-white'
                      : 'border-white/80 bg-white text-emerald-700 hover:bg-emerald-50'
                  } ${busyId === todo.id ? 'animate-pulse' : ''}`}
                  title={completed ? 'Completed' : 'Complete'}
                >
                  <CheckIcon className="h-4 w-4" />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
